module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\".product\" ng-bind=\"object.title || 'Chemical Program'\"></a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\"><div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/chemical_programs/templates/detail.section.html
// module id = 800
// module chunks = 0